import React from 'react';
import Footer1 from './Footer1';
import Footer2 from './Footer2';

const Footer = () => {
  return <>
  <Footer1/>
  <Footer2/>
  </>;
};

export default Footer;
